import React, { useEffect, useRef, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useModel } from "../hooks/modelcontex";
import {
  getBadges,
  getPoemDetails,
  getProfileDetails,
  getStoryCategories,
  getStoryDetails,
  getUserPortfolioNew,
} from "./utilities/ApiCalls";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Layout from "../Layout/Layout";
import Default from "../Images/Defaultprofile.png";
import Constant, { statusFailure } from "./Constant";
import { Link2, Plus, Share2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import FlipBooks from "./FlipBooks";
import { processPortfolioNewToPages } from "./utilities/PortfolioNewProcessor";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ProfileImage from "../Componets/ProfileImage";
import SindhiFontWoff2 from "../fonts/SHREE-DEV7-0714.woff2";
import SindhiFontWoff from "../fonts/SHREE-DEV7-0714.woff";

const SindhiFontStyles = createGlobalStyle`
  @font-face {
    font-family: 'SHREE-DEV7-0714';
    src:
      url(${SindhiFontWoff2}) format('woff2'),
      url(${SindhiFontWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const MyProfileDetails = () => {
  const [t] = useTranslation();
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const [stories, setStories] = useState([]);
  const [poems, setPoems] = useState([]);
  const [profile, setProfile] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [length, setLength] = useState(1);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [tab, settab] = useState(new URLSearchParams(location.search).get("tab") || "stories");
  const { setFollowOptions } = useModel();
  const history = useHistory();
  const [sharelink, setShareLink] = useState(false);
  const [userBadge, setUserBadge] = useState([]);
  const [badgeIds, setBadgeIds] = useState([]);
  const [link, setlink] = useState("");
  const [rawPortData, setRawPortData] = useState(null);
  const [port, setPort] = useState([]);
  const [portMeta, setPortMeta] = useState({
    bookName: "eBook",
    authorName: "",
  });

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const filterOutDrafts = (items = []) =>
    items.filter((item) => item?.isDraft !== true);

  const divRef = useRef(null);

  // Consolidated profile and badge fetching
  useEffect(() => {
    const fetchProfileDetails = async () => {
      try {
        const response = await getProfileDetails();
        if (response.status !== statusFailure) {
          const profileData = response.data.data;
          setProfile(profileData);

          const userBadgeData = profileData.userBadge;
          if (userBadgeData) {
            if (userBadgeData.badgeDetails?.length) {
              setUserBadge(userBadgeData.badgeDetails);
            } else {
              setBadgeIds(userBadgeData.badgeIds || []);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching profile details:", error);
      }
    };

    fetchProfileDetails();
  }, []);

  // Badges fetching
  const fetchBadges = async () => {
    try {
      if (badgeIds && badgeIds.length > 0) {
        const badgeResponses = await Promise.all(
          badgeIds.map(async (id) => {
            const response = await getBadges(id);
            // Check if response contains empty data array but success status
            if (
              response.data &&
              response.data.status === "Success" &&
              (response.data.data === null ||
                (Array.isArray(response.data.data) &&
                  response.data.data.length === 0))
            ) {
              return null; // Return null for empty data
            }
            return response.data;
          })
        );

        // Filter out null responses and empty data
        const validBadges = badgeResponses
          .filter(Boolean)
          .filter(
            (badge) =>
              badge.data &&
              (Array.isArray(badge.data) ? badge.data.length > 0 : true)
          );

        setUserBadge(validBadges);
      }
    } catch (error) {
      console.error("Error getting user Badges:", error);
      setUserBadge([]);
    }
  };

  useEffect(() => {
    fetchBadges();
  }, [badgeIds]);

  // Window resize handler
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Call handler right away so state gets updated with initial window size

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Click outside handler for share link
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShareLink(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  async function portfolioFetch() {
    try {
      const response = await getUserPortfolioNew(profile._id);

      if (!response || response.status !== "Success" || !response.data) {
        console.warn("Unexpected portfolio data format:", response);
        setRawPortData(null);
        setPort([]);
        return [];
      }
      const portfolioData = response.data;
      setRawPortData(portfolioData);
      const pages = await processPortfolioNewToPages(portfolioData);
      const meta = {
        bookName: portfolioData.BookName || "eBook",
        authorName: portfolioData.AuthorName || "",
      };

      setPortMeta(meta);
      setPort(pages);
      return pages;
    } catch (error) {
      console.error("Error fetching portfolio", error);
      setRawPortData(null);
      setPort([]);
      return [];
    }
  }

  // Reprocess on resize
  useEffect(() => {
    if (rawPortData && tab === "portfolio") {
      const processPages = async () => {
        const pages = await processPortfolioNewToPages(rawPortData);
        setPort(pages);
      };
      processPages();
    }
  }, [windowSize.width, rawPortData, tab]);

  // Handlers for follows and content fetching
  const HandleClickFollows = () => {
    setFollowOptions("followers");
    history.push(`/userFollowers/${profile._id}`);
  };

  const HandleClickFollowing = () => {
    setFollowOptions("following");
    history.push(`/userFollowers/${profile._id}`);
  };

  function getUserStories() {
    let params = {
      userId: profile._id,
      user_id: profile._id,
    };
    getStoryDetails(params)
      .then((response) => {
        setStories(filterOutDrafts(response.data || []));
        setPageNo(response.pageNo);
        setLength(response.length);
      })
      .catch((error) => {
        console.error("Error fetching stories:", error);
      });
  }

  function getUserPoems(page, categoryId) {
    let params = { moduleType: 2 };
    getStoryCategories(params).then((response) => {
      setCategories(response.data);
    });

    params = {
      userId: profile._id,
      user_id: profile._id,
      pageNo: page || pageNo,
    };

    if (categoryId) {
      params.categoryId = categoryId;
      setCategoryId(categoryId);
    } else {
      setCategoryId("");
    }

    getPoemDetails(params)
      .then((response) => {
        setPoems(filterOutDrafts(response.data || []));
        setPageNo(response.pageNo);
        setLength(response.length);
      })
      .catch((error) => {
        console.error("Error fetching poems:", error);
      });
  }

  // Initial data fetch based on tab
  useEffect(() => {
    if (profile._id) {
      const initialTab = new URLSearchParams(location.search).get("tab") || "stories";
      if (initialTab === "portfolio") {
        portfolioFetch();
      } else if (initialTab === "poetries") {
        getUserPoems();
      } else {
        getUserStories();
      }
    }
  }, [profile]);

  // Clipboard copy function
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com"))
      return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  const timeAgo = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}D AGO`;
    if (hours > 0) return `${hours}H AGO`;
    if (minutes > 0) return `${minutes}M AGO`;
    return "JUST NOW";
  };

  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    // Strip HTML tags
    const plainText = text.replace(/<[^>]+>/g, "");
    if (plainText.length <= maxLength) return plainText;
    return plainText.substring(0, maxLength) + "...";
  };

  return (
    <Layout>
      <Root tab={tab}>
        <SindhiFontStyles />
        <div className={`profile-container  ${sharelink && "opacity"} `}>
          <div className="profile-header">
            <div className="profile-image">
              <ProfileImage
                src={profile.profilePic}
                name={profile.name}
                size={120}
                className="img"
                alt="profileImage"
                proxiedUrl={proxiedUrl}
                avatarProps={{
                  className: "img-default",
                  border: "4px solid var(--color-surface)",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              />
            </div>

            <div className="user-details">
              <div className="Name">{profile.userName || profile.name}</div>
              <div className="subtitle-text">Writer & Poet</div>

              <div className="Intro">
                {profile.intro ? (
                  profile?.intro.split("\n").map((line, idx) => (
                    <span key={idx}>
                      {line}
                      <br />
                    </span>
                  ))
                ) : (
                  <p className="Intro">No Intro</p>
                )}
              </div>

              {/* Badges Section */}
              <div className="badge-icons">
                {userBadge && userBadge.length > 0 ? (
                  userBadge.map((badge, index) => (
                    <div className="badge-container" key={index}>
                      <img
                        src={badge.icon}
                        alt={badge.title}
                        className="badge-icon"
                        crossOrigin="anonymous"
                      />
                      <div className="tooltip">{badge.title}</div>
                    </div>
                  ))
                ) : (
                  <div className="no-badges">No Badges</div>
                )}
              </div>

              <div className="follow-text">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={HandleClickFollows}
                >
                  {profile?.followersList?.length || "0"}{" "}
                  {t("Profile.Followers")}
                </span>{" "}
                <span> • </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={HandleClickFollowing}
                >
                  {" "}
                  {profile?.followingList?.length || "0"}{" "}
                  {t("Profile.Following")}{" "}
                </span>
              </div>

              <div className="button">
                <button
                  onClick={() => {
                    setShareLink(true);
                    setlink(
                      `https://www.storytent.in/userprofile/${profile._id}`
                    );
                  }}
                  className="btn"
                >
                  {t("Profile.Share")}
                </button>
                <Link to={`/setting/edit`}>
                  <button className="btn">{t("Profile.EditProfile")}</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="tab">
            <div
              onClick={() => {
                settab("stories");
                getUserStories();
              }}
              className="story-tab-title"
            >
              {t("Profile.Stories")}
            </div>
            <div
              onClick={() => {
                settab("poetries");
                getUserPoems();
              }}
              className="poem-tab-title"
            >
              {t("Profile.Poetries")}
            </div>
            <div
              onClick={() => {
                settab("portfolio");
                portfolioFetch();
              }}
              className="profile-tab-title"
            >
              {t("Profile.Portfolio")}
            </div>
          </div>

          <div className="divider" />

          <div
            className={`tab-content ${
              tab === "portfolio" ? "portfolio-tab" : ""
            }`}
          >
            {tab === "stories" &&
              stories.length > 0 &&
              stories.map((data) => {
                const isSindhiStory =
                  (data.language || "").toLowerCase() === "sindhi";

                return (
                  <Link
                    key={data._id}
                    to={`/story-details/${data._id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="cart">
                      <div
                        className="title"
                        style={
                          isSindhiStory
                            ? {
                                fontFamily: "SHREE-DEV7-0714",
                                fontSize: "16px",
                              }
                            : undefined
                        }
                      >
                        {data.name}
                      </div>
                      {(data.description || data.story) && (
                        <div
                          className={`story-snippet${
                            isSindhiStory ? " sindhi-text" : ""
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: truncateText(
                              data.description || data.story,
                              150
                            ),
                          }}
                        ></div>
                      )}
                    </div>
                  </Link>
                );
              })}

            {tab === "poetries" &&
              poems.length > 0 &&
              poems.map((data) => {
                const isSindhiPoem =
                  (data.language || "").toLowerCase() === "sindhi";

                return (
                  <Link
                    key={data._id}
                    to={`/poem-details/${data._id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="cart">
                      <div
                        className="title"
                        style={
                          isSindhiPoem
                            ? {
                                fontFamily: "SHREE-DEV7-0714",
                                fontSize: "16px",
                              }
                            : undefined
                        }
                      >
                        {data.name}
                      </div>
                      {(data.description || data.story) && (
                        <div
                          className={`story-snippet${
                            isSindhiPoem ? " sindhi-text" : ""
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: truncateText(
                              data.description || data.story,
                              150
                            ),
                          }}
                        ></div>
                      )}
                    </div>
                  </Link>
                );
              })}

            {tab === "portfolio" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  textAlign: "center",
                  gridColumn: "1 / -1",
                }}
              >
                <div style={{ marginBottom: "20px", marginTop: "0px", display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                  {windowSize.width > 700 ? (
                    <button
                      className="edit-portfolio-btn"
                      onClick={() =>
                        history.push("/settings", { initialTab: "portfolio" })
                      }
                    >
                      {t("Settings.EditPortfolio", "Edit eBook")}
                    </button>
                  ) : (
                    <Link to={`/setting/portfolio`}>
                      <button className="edit-portfolio-btn">
                        {t("Settings.EditPortfolio", "Edit eBook")}
                      </button>
                    </Link>
                  )}
                  {port.length > 0 && (
                    <div
                      title={t("Profile.SharePortfolio", "Share eBook")}
                      style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "var(--color-surface)", border: "1px solid var(--color-border)" }}
                      onClick={() => {
                        setShareLink(true);
                        setlink(
                          `https://www.storytent.in/userprofile/${profile._id}?tab=portfolio`
                        );
                      }}
                    >
                      <Share2 size={20} color="var(--color-text)" />
                    </div>
                  )}
                </div>

                {port.length > 0 ? (
                  <FlipBooks data={port} meta={portMeta} />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    {t("Profile.NoPortfolio")}
                  </div>
                )}
              </div>
            )}
          </div>

          {tab === "stories" && stories.length === 0 && (
            <div className="no-content">{t("Profile.NoStory")}</div>
          )}

          {tab === "poetries" && poems.length === 0 && (
            <div className="no-content">{t("Profile.NoPoetry")} </div>
          )}
        </div>

        {sharelink && (
          <div ref={divRef} className="share-box">
            <div
              onClick={() => setShareLink(false)}
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                cursor: "pointer",
              }}
            >
              <Plus
                style={{
                  transform: "rotate(45deg)",
                  color: "var(--color-text)",
                }}
              />
            </div>
            <div className="share-title">Share</div>
            <div className="share-link-icon">
              <span
                onClick={() => {
                  copyToClipboard(link);
                  setShareLink(false);
                }}
                style={{ cursor: "pointer" }}
                className="icon-container"
              >
                <Link2 color="var(--color-text)" />
              </span>
            </div>
            <div className="share-copy-text">Copy Link</div>
          </div>
        )}
      </Root>
    </Layout>
  );
};

export default MyProfileDetails;

const Root = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
  font-family: "Merriweather", serif;

  /* Inherits global background from Layout/Body but we can ensure transparent bg here */

  .profile-container {
    width: 100%;
    max-width: 1200px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
  }

  .profile-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    max-width: 600px;
  }

  /* Badge container styles */
  .badge-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    min-height: 20px; /* reserve space */
  }

  .no-badges {
    color: var(--color-text-tertiary);
    font-size: 14px;
    font-style: italic;
  }

  .badge-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin: 0 4px;
    z-index: 1;
    transition: transform 0.2s ease;
  }

  .badge-container:hover {
    transform: scale(1.1);
  }

  /* Badge image styles */
  .badge-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid var(--color-surface, #fff);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: border 0.2s ease;
  }

  /* Tooltip styles */
  .tooltip {
    visibility: hidden;
    position: absolute;
    background-color: var(--color-text);
    color: var(--color-surface);
    text-align: center;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 12px;
    white-space: nowrap;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
    z-index: 100;
    opacity: 0;
    transition: opacity 0.3s;
    font-family: sans-serif;
  }

  .tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--color-text) transparent transparent transparent;
  }

  .badge-container:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }

  .Name {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-primary);
    margin-top: 15px;
    font-family: "Merriweather", serif;
  }

  .subtitle-text {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: var(--color-text);
    margin-top: 5px;
    font-family: sans-serif;
    font-weight: 600;
  }

  .Intro {
    font-size: 15px;
    color: var(--color-text);
    margin-top: 10px;
    font-family: "Merriweather", serif;
    font-style: italic;
    max-width: 600px;
    line-height: 1.5;
  }

  .follow-text {
    font-size: 13px;
    margin-top: 10px;
    color: var(--color-text);
    font-family: sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }

  .button {
    display: flex;
    gap: 15px;
    margin-top: 15px;
    justify-content: center;
  }

  .btn {
    background-color: white;
    color: #263a38;
    border: 1px solid var(--color-border);
    border-radius: 30px;
    font-size: 13px;
    padding: 8px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;

    &:hover {
      background-color: #f0f0f0;
      border-color: var(--color-text);
    }
  }

  .profile-image {
    margin-top: 10px;
  }

  .img {
    border-radius: 50%;
    width: 120px;
    height: 120px;
    object-fit: cover;
    border: 4px solid var(--color-surface);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .img-default {
    /* Styles are handled by DefaultAvatar component */
  }

  /* Tabs */
  .tab {
    display: flex;
    margin-top: 30px;
    gap: 30px;
    margin-bottom: 0px;
  }

  .story-tab-title,
  .profile-tab-title,
  .poem-tab-title {
    color: var(--color-text);
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding-bottom: 10px;
    cursor: pointer;
    font-family: sans-serif;
    border-bottom: 2px solid transparent;
    opacity: 0.6;
    transition: all 0.2s;
  }

  .story-tab-title {
    border-bottom-color: ${(props) =>
      props.tab === "stories" ? "var(--color-text)" : "transparent"};
    opacity: ${(props) => (props.tab === "stories" ? "1" : "0.6")};
  }

  .poem-tab-title {
    border-bottom-color: ${(props) =>
      props.tab === "poetries" ? "var(--color-text)" : "transparent"};
    opacity: ${(props) => (props.tab === "poetries" ? "1" : "0.6")};
  }

  .profile-tab-title {
    border-bottom-color: ${(props) =>
      props.tab === "portfolio" ? "var(--color-text)" : "transparent"};
    opacity: ${(props) => (props.tab === "portfolio" ? "1" : "0.6")};
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--color-border);
    margin-bottom: 20px;
    max-width: 1000px;
  }

  /* Grid content */
  .tab-content {
    display: grid;
    width: 100%;
    max-width: 1000px;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    padding: 10px 20px;
    background-color: var(--color-raw-porcelain);

    &.portfolio-tab {
      background-color: transparent;
    }

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .cart {
    width: 100%;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    padding: 24px;
    transition: transform 0.3s ease, box-shadow 0.3s ease,
      border-color 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    text-align: left;
    color: var(--color-text-tertiary);

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      border-color: var(--color-primary);
    }
  }

  .title {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text-tertiary);
    margin: 0;
    line-height: 1.3;
    font-family: "Merriweather", serif;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--color-border);
  }

  .story-snippet {
    font-size: 14px;
    line-height: 1.6;
    color: var(--color-text-tertiary);
    font-family: "Merriweather", serif;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: left;

    /* Drop cap styling for first letter */
    &::first-letter {
      float: left;
      font-size: 48px;
      line-height: 0.7;
      padding-right: 8px;
      padding-top: 4px;
      font-weight: 400;
      font-style: italic;
      color: var(--color-text-tertiary);
    }

    /* Remove default paragraph margins and styling */
    p {
      margin: 0;
      display: inline;
    }
  }

  .story-snippet.sindhi-text,
  .story-snippet.sindhi-text p,
  .story-snippet.sindhi-text strong,
  .story-snippet.sindhi-text em,
  .story-snippet.sindhi-text u {
    font-family: "SHREE-DEV7-0714", "Merriweather", serif;
    font-size: 16px;
  }

  .no-content {
    text-align: center;
    color: var(--color-text);
    font-family: "Merriweather", serif;
    font-style: italic;
    margin-top: 40px;
  }

  /* Portfolio specific */
  .edit-portfolio-btn {
    background-color: transparent;
    color: var(--color-text);
    border: 1px solid var(--color-border);
    border-radius: 30px;
    font-size: 14px;
    padding: 10px 24px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: var(--color-text);
      color: var(--color-surface);
    }
  }

  /* Share Box */
  .share-box {
    width: 300px;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    padding: 20px;
    border-radius: 12px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .share-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    color: var(--color-text);
  }

  .share-link-icon {
    margin: 10px 0;
  }

  .icon-container {
    background-color: var(--color-background);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  .share-copy-text {
    margin-top: 10px;
    font-size: 12px;
    color: var(--color-text-tertiary, #888);
  }

  .opacity {
    opacity: 0.5;
    pointer-events: none;
  }
`;
